import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { LimitedFeature } from '../../components/LimitedFeature';
import { PATH_REFERENCES } from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { Accordion } from './Accordion';

export const ReferencesPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.References);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Référentiel')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_REFERENCES,
            label: 'référentiel',
            key: 'references',
          },
        ]}
      />
      <PageTitle title="Référentiel" />
      <LimitedFeature />
      <Accordion />
    </>
  );
};
